import React, { Component } from 'react'
import { Button } from 'antd'
import MaterialRequestLineItem from './MaterialRequestLineItem'

class MaterialRequestItems extends Component {
  render() {
    const { allItems } = this.props
    return (
      <div>
        <div className="materialRequestLineItemBackground">
          <div className="jobsBar">
            Items
            <div className="jobsBarAdd">
              <i className="fa fa-plus-square" aria-hidden="true" />
              &nbsp;<div className="addJobLabel" onClick={this.props.addItem}>
                ADD ITEM
              </div>
            </div>
          </div>
          <div className="row padding10">
            <div className="col-md-3">Name</div>
            <div className="col-md-2">Quantity</div>
            <div className="col-md-3">Notes</div>
            {!this.props.templateManagement && <div className="col-md-2">Quantity Delivered</div>}
            <div className="col-md-2 text-right">Actions</div>
          </div>
          <MaterialRequestLineItem
            allItems={allItems}
            templateManagement={this.props.templateManagement}
            requestItems={this.props.requestItems}
            deleteItem={this.props.deleteItem}
            onItemChange={this.props.onItemChange}
            moveUp={this.props.moveUp}
            moveDown={this.props.moveDown}
          />
          <div className="row padding10">
            <div className="col-md-12 text-right marginTop10">
              <Button icon="plus" onClick={this.props.addItem}>
                Add New Item
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default MaterialRequestItems



// WEBPACK FOOTER //
// ./src/components/MaterialRequestItems.js